jQuery(document).on("click",".js-toggle-slide-nav",function(){  
  jQuery("body").addClass('drawer-menu-open');
});
jQuery(document).on("click",".drawer-close",function(){  
  jQuery(".js-toggle-slide-nav").removeClass('is-active');
  jQuery(".drawer--menu").removeClass('js-menu--is-open');
  jQuery("body").removeClass('drawer-menu-open');
});
// mobile menu drawer close = End


//COLLECTION TABING
$(document).ready(function () {
  jQuery(".cl_main_tabs li").eq(0).addClass("current");
  jQuery(".tabs-content").find(".cl_maintab-content").eq(0).addClass("current");
  $("ul.cl_main_tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.cl_main_tabs li").removeClass("current");
    $(".cl_maintab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
    $(".producttab-itemslick").slick("refresh");
  });
});

jQuery(document).on("click",".store_location_all",function(){  
  jQuery(this).hide();
  jQuery('.store_location_list').show();
});

//REVIEW SLIDER

$('.review_main_slider').slick({
  dots: true,
  arrows: false,
  infinite: false,
  centerMode: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  centerMode: true,
  centerPadding:'0px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        centerPadding:'50px'
      }
    }
  ]
});


//WORK STEPS SLIDER
 
$('.work_steps_slider').slick({
  dots: true,
  arrows: false,
  infinite: false,
  centerMode: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  centerMode: true,
  centerPadding:'0px',
  responsive: [
    {
      breakpoint: 9999,
      settings: {
        slider: "unslick"
      }
    },
    {
      breakpoint: 650,
      settings: {
        slider: "slick"
      }
    },
    {
      breakpoint: 649,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        centerPadding:'60px'
      }
    }
  ]
});

//PRODUCT INGRADIENTS SLIDER
 
$('.product_ingradients_slider').slick({
  dots: true,
  arrows: false,
  infinite: false,
  centerMode: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  centerMode: true,
  centerPadding:'0px',
  responsive: [
    {
      breakpoint: 9999,
      settings: {
        slider: "unslick"
      }
    },
    {
      breakpoint: 650,
      settings: {
        slider: "slick"
      }
    },
    {
      breakpoint: 649,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        centerPadding:'50px'
      }
    }
  ]
});

// ACCORDIANT PANELS
$(document).ready(function() {
  $(".collapsible-panel > .collapsible-panel-heading").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".collapsible-panel-content")
        .slideUp(200);
      $(".collapsible-panel > .collapsible-panel-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".collapsible-panel > .collapsible-panel-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".collapsible-panel > .collapsible-panel-heading").removeClass("active");
      $(this).addClass("active");
      $(".collapsible-panel-content").slideUp(200);
      $(this)
        .siblings(".collapsible-panel-content")
        .slideDown(200);
    }
  });
});

// Testimonials Slider
$('.testimonials-slick').slick({
  dots: false,
  arrows: false,
  infinite: false,
  centerMode: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});

// filter view all
jQuery(document).on("click",".show_all__li",function(){
    jQuery('.li-viewless').show();
    jQuery('.li-viewall').hide();
    jQuery(".variant-count").removeClass('hide-vl');
    jQuery('.hide_all__li').show();
    jQuery(this).hide();
  });
  jQuery(document).on("click",".hide_all__li",function(){
    jQuery('.li-viewless').hide();
    jQuery('.li-viewall').show();
    jQuery('.show_all__li').show();
    jQuery(".show-vl").addClass('hide-vl');
    jQuery(this).hide();
  });

//:: START :: sections/main-product.liquid  ::
$(".product---gallery-v1").find(".product__gallery").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    speed: 200,
    asNavFor: ".product__thumbnail",
    arrows: false,
    dots: false,
    draggable: false,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          draggable: true,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M16.25 10.8333L6.595 10.8333L10.345 14.5833L9.16667 15.7617L3.405 9.99999L9.16667 4.23832L10.345 5.41666L6.595 9.16666L16.25 9.16666L16.25 10.8333Z" fill="currentColor"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3.75 10.8333L13.405 10.8333L9.655 14.5833L10.8333 15.7617L16.595 9.99999L10.8333 4.23832L9.655 5.41666L13.405 9.16666L3.75 9.16666L3.75 10.8333Z" fill="currentColor"/></svg></button>',
        }
      }
    ]
});

$(".product---gallery-v1").find(".product__thumbnail").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".product__gallery",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    speed: 200,
    infinite: false,
    arrows: true,
    prevArrow:
      '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 921,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 521,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
});

// recharge app
$(document).ready(function () {
  setInterval(function(){
    if($('.subsave-usps').length == 0){
      jQuery(".smartrr-group-active [data-smartrr-selling-plan-group-plans]").append('<ul class="subsave-usps"> <li>FREE shipping for orders above $99+</li> <li>Save 10% of your first purchase</li> <li>Fast and easy cancel, no questions asked</li> </ul>');
    }
  },1000);
});

/*
function startDailyCountdown() {
  const timerElement = document.querySelector('.carttimer');

  function updateTimer() {
    // Calculate time remaining until midnight
    const now = new Date();
    const midnight = new Date();
    midnight.setHours(23, 59, 60, 0); // Set to 24h 59m 60s

    // Calculate the difference in milliseconds
    const timeDiff = midnight - now;

    // Calculate hours, minutes, and seconds from the time difference
    let hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 23);
    let minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
    let seconds = Math.floor((timeDiff / 1000) % 60);

    // Format hours, minutes, and seconds with leading zeros
    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    // Update the timer display
    timerElement.textContent = `${hours}h ${minutes}m ${seconds}s`;

    // Reset the timer at midnight
    if (timeDiff <= 0) {
      // Reset time to 24h 59m 60s at midnight and start the countdown again
      midnight.setDate(midnight.getDate() + 1);
    }
  }

  // Update the timer every second
  setInterval(updateTimer, 1000);
}
// Start the daily countdown when the page loads
startDailyCountdown();
*/

function startThirtyMinuteCountdown() {
  const timerElement = document.querySelector('.carttimer');

  // Set the target time 30 minutes from now only once
  let targetTime = new Date(new Date().getTime() + 30 * 60 * 1000);

  function updateTimer() {
    // Get the current time
    const now = new Date();

    // Calculate the difference in milliseconds
    const timeDiff = targetTime - now;

    // Check if the countdown has reached zero, and reset it if necessary
    if (timeDiff <= 0) {
      // Reset the target time to another 30 minutes from now
      targetTime = new Date(new Date().getTime() + 30 * 60 * 1000);
    }

    // Calculate minutes and seconds from the time difference
    let minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
    let seconds = Math.floor((timeDiff / 1000) % 60);

    // Format minutes and seconds with leading zeros
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    // Update the timer display
    timerElement.textContent = `${minutes}m ${seconds}s`;
  }

  // Update the timer every second
  setInterval(updateTimer, 1000);
}

// Start the countdown when the page loads
startThirtyMinuteCountdown();

/*jQuery(document).on('click', function (e) {
  if (jQuery('html').hasClass('modal-open') && !$(e.target).closest('.js-modal-open-search-modal').length) {
    jQuery('#SearchModal').removeClass("modal--is-active");
    jQuery('html').removeClass("modal-open");
    jQuery('.js-modal-open-search-modal').attr('aria-expanded',false);
  }
});

jQuery(document).on("click",'a[href="/search"]',function(e){
  jQuery('#SearchModal').addClass("modal--is-active");
  jQuery('html').addClass("modal-open");
  jQuery('.js-modal-open-search-modal').attr('aria-expanded',true);
  e.preventDefault();
});*/
